export const Loader = () => {
  return (
    <div
      className={`w-14 h-[22.9px] animate-dots`}
      style={{
        color: 'black'
      }}
    ></div>
  );
};
